import { Component, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GenericButton } from '@models/models';

@Component({
	selector: 'confirm-general-modal',
	template: require('./confirm-general-modal.component.html'),
	styles: [require('./confirm-general-modal.component.scss')]
})
export class ConfirmGeneralModalComponent {
	@Input() title?: string;
	@Input() htmlText?: string;
	@Input() text: string;
	@Input() buttons: Array<GenericButton>;
	@Input() columnButtons?: boolean;

	constructor(private ngbActiveModal: NgbActiveModal) {}

	closeWithAction(action: string): void {
		this.ngbActiveModal.close(action);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts